<template>
  <div>
    <v-row dense>
      <v-col cols="10">
        <h2 class="b-indicator__collapse-title">1. Значение показателя</h2>
        <h3 class="b-indicator__collapse-subtitle">Исходные данные:</h3>
      </v-col>
    </v-row>
    <block-od :item="item" :row-of-values="rowOfValues"/>
    <v-row dense>
      <v-col cols="10">
        <p>
          <span class="font-weight-bold mb-1">Форма 5.02. (фрагмент)</span><br>
          Общая численность обучающихся по программам бакалавриата, программам специалитета, программам магистратуры
          <br>
          по данным формы ВПО-1, человек
        </p>
      </v-col>
    </v-row>
    <table>
      <thead>
      <tr>
        <th rowspan="3" colspan="3" class="text-left kcp-td">Уровни и формы образования</th>
        <th colspan="3">Обучающихся (искл. квоту иностр.граждан)</th>
        <th rowspan="3" style="vertical-align: bottom">...</th>
        <th colspan="3">Иностр.граждан, обучающихся по квоте</th>
        <th rowspan="3" style="vertical-align: bottom">...</th>
        <th rowspan="4" class="border-right-zero" style="min-width: 66px;border-bottom: 0!important;"></th>
        <th rowspan="2" class="border-right-zero" colspan="3">Всего обучающихся</th>
      </tr>
      <tr>
        <th colspan="3">
          всего
        </th>
        <th colspan="3"></th>
<!--        <th colspan="3">-->
<!--          Всего обучающихся-->
<!--        </th>-->
      </tr>
      <tr>
        <th>
          на 01.10.2021
        </th>
        <th>
          на 01.10.2022
        </th>
        <th>
          на 01.10.2023
        </th>

        <th>
          на 01.10.2021
        </th>
        <th>
          на 01.10.2022
        </th>
        <th>
          на 01.10.2023
        </th>
        <th rowspan="2" style="border-bottom: 0">
          на 01.10.2021 г.<br/>
          <span class="font-weight-bold">гр.3 + гр.7</span>
        </th>
        <th rowspan="2" style="border-bottom: 0">
          на 01.10.2022 г.<br/>
          <span class="font-weight-bold">гр.4 + гр.8</span>
        </th >
        <th rowspan="2" class="border-right-zero"  style="border-bottom: 0">
          на 01.10.2023 г.<br/>
          <span class="font-weight-bold">гр.5 + гр.9</span>
        </th>

      </tr>
      <tr style="border-top: 1px solid #B7CED9">
        <th colspan="1" class="border-right-zero" style="text-align: left"><span>1</span></th>
        <th colspan="2" style="text-align: left"><span >2</span></th>
        <th v-for="(item) in 3" :key="item">{{ item + 2 }}</th>
        <th>...</th>
        <th v-for="(item) in 3" :key="item">{{ item + 6 }}</th>
        <th>...</th>
      </tr>
      </thead>
      <tbody>
      <tr>
        <td rowspan="3" style="text-align: left; vertical-align: top" class="border-right-zero pt-1" >
          <span class="usl-name">Бакалавриат</span>
        </td>
        <td colspan="2" class="text-left kcp-name">очная форма</td>
        <td>{{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nsbco20, 0, 'integer') }}</td>
        <td>{{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nsbco21, 0, 'integer') }}</td>
        <td>{{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nsbco22, 0, 'integer') }}</td>
        <td>...</td>
        <td>{{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nqbco20, 0, 'integer') }}</td>
        <td>{{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nqbco21, 0, 'integer') }}</td>
        <td>{{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nqbco22, 0, 'integer') }}</td>
        <td>...</td>
        <td rowspan="9" class="border-bottom-zero border-right-zero"><img :src="require('@/assets/images/Vector_rigth_arrow.svg')" alt=""/></td>
        <td class="border-right-zero">{{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nobco20, 0, 'integer') }}</td>
        <td class="border-right-zero">{{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nobco21, 0, 'integer') }}</td>
        <td class="border-right-zero">{{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nobco22, 0, 'integer') }}</td>
      </tr>
      <tr>
        <td colspan="2" class="text-left kcp-name">очно-заочная форма</td>
        <td>{{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nsbcv20, 0, 'integer') }}</td>
        <td>{{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nsbcv21, 0, 'integer') }}</td>
        <td>{{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nsbcv22, 0, 'integer') }}</td>
        <td>...</td>
        <td>{{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nqbcv20, 0, 'integer') }}</td>
        <td>{{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nqbcv21, 0, 'integer') }}</td>
        <td>{{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nqbcv22, 0, 'integer') }}</td>
        <td>...</td>
        <td class="border-right-zero">{{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nobcv20, 0, 'integer') }}</td>
        <td class="border-right-zero">{{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nobcv21, 0, 'integer') }}</td>
        <td class="border-right-zero">{{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nobcv22, 0, 'integer') }}</td>
      </tr>
      <tr>
        <td colspan="2" class="text-left kcp-name">заочная форма</td>
        <td>{{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nsbcz20, 0, 'integer') }}</td>
        <td>{{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nsbcz21, 0, 'integer') }}</td>
        <td>{{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nsbcz22, 0, 'integer') }}</td>
        <td>...</td>
        <td>{{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nqbcz20, 0, 'integer') }}</td>
        <td>{{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nqbcz21, 0, 'integer') }}</td>
        <td>{{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nqbcz22, 0, 'integer') }}</td>
        <td>...</td>
        <td class="border-right-zero">{{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nobcz20, 0, 'integer') }}</td>
        <td class="border-right-zero">{{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nobcz21, 0, 'integer') }}</td>
        <td class="border-right-zero">{{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nobcz22, 0, 'integer') }}</td>
      </tr>
      <tr>
        <td rowspan="3" style="text-align: left; vertical-align: top" class="border-right-zero pt-1" >
          <span class="usl-name">Специалитет</span>
        </td>
        <td colspan="2" class="kcp-name text-left">очная форма</td>
        <td>{{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nsspo20, 0, 'integer') }}</td>
        <td>{{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nsspo21, 0, 'integer') }}</td>
        <td>{{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nsspo22, 0, 'integer') }}</td>
        <td>...</td>
        <td>{{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nqspo20, 0, 'integer') }}</td>
        <td>{{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nqspo21, 0, 'integer') }}</td>
        <td>{{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nqspo22, 0, 'integer') }}</td>
        <td>...</td>
        <td class="border-right-zero">{{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nospo20, 0, 'integer') }}</td>
        <td class="border-right-zero">{{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nospo21, 0, 'integer') }}</td>
        <td class="border-right-zero">{{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nospo22, 0, 'integer') }}</td>
      </tr>
      <tr>
        <td colspan="2" class="text-left kcp-name">очно-заочная форма</td>
        <td>{{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nsspv20, 0, 'integer') }}</td>
        <td>{{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nsspv21, 0, 'integer') }}</td>
        <td>{{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nsspv22, 0, 'integer') }}</td>
        <td>...</td>
        <td>{{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nqspv20, 0, 'integer') }}</td>
        <td>{{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nqspv21, 0, 'integer') }}</td>
        <td>{{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nqspv22, 0, 'integer') }}</td>
        <td>...</td>
        <td class="border-right-zero">{{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nospv20, 0, 'integer') }}</td>
        <td class="border-right-zero">{{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nospv21, 0, 'integer') }}</td>
        <td class="border-right-zero">{{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nospv22, 0, 'integer') }}</td>
      </tr>
      <tr>
        <td colspan="2" class="text-left kcp-name">заочная форма</td>
        <td>{{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nsspz20, 0, 'integer') }}</td>
        <td>{{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nsspz21, 0, 'integer') }}</td>
        <td>{{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nsspz22, 0, 'integer') }}</td>
        <td>...</td>
        <td>{{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nqspz20, 0, 'integer') }}</td>
        <td>{{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nqspz21, 0, 'integer') }}</td>
        <td>{{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nqspz22, 0, 'integer') }}</td>
        <td>...</td>
        <td class="border-right-zero">{{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nospz20, 0, 'integer') }}</td>
        <td class="border-right-zero">{{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nospz21, 0, 'integer') }}</td>
        <td class="border-right-zero">{{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nospz22, 0, 'integer') }}</td>
      </tr>
      <tr>
        <td rowspan="3" style="text-align: left; vertical-align: top" class="border-right-zero pt-1" >
          <span class="usl-name">Магистратура</span>
        </td>
        <td colspan="2" class="text-left kcp-name">очная форма</td>
        <td>{{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nsmgo20, 0, 'integer') }}</td>
        <td>{{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nsmgo21, 0, 'integer') }}</td>
        <td>{{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nsmgo22, 0, 'integer') }}</td>
        <td>...</td>
        <td>{{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nqmgo20, 0, 'integer') }}</td>
        <td>{{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nqmgo21, 0, 'integer') }}</td>
        <td>{{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nqmgo22, 0, 'integer') }}</td>
        <td>...</td>
        <td class="border-right-zero">{{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nomgo20, 0, 'integer') }}</td>
        <td class="border-right-zero">{{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nomgo21, 0, 'integer') }}</td>
        <td class="border-right-zero">{{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nomgo22, 0, 'integer') }}</td>
      </tr>
      <tr>
        <td colspan="2" class="text-left kcp-name">очно-заочная форма</td>
        <td>{{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nsmgv20, 0, 'integer') }}</td>
        <td>{{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nsmgv21, 0, 'integer') }}</td>
        <td>{{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nsmgv22, 0, 'integer') }}</td>
        <td>...</td>
        <td>{{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nqmgv20, 0, 'integer') }}</td>
        <td>{{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nqmgv21, 0, 'integer') }}</td>
        <td>{{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nqmgv22, 0, 'integer') }}</td>
        <td>...</td>
        <td class="border-right-zero">{{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nomgv20, 0, 'integer') }}</td>
        <td class="border-right-zero">{{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nomgv21, 0, 'integer') }}</td>
        <td class="border-right-zero">{{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nomgv22, 0, 'integer') }}</td>
      </tr>
      <tr>
        <td colspan="2" class="text-left kcp-name">заочная форма</td>
        <td>{{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nsmgz20, 0, 'integer') }}</td>
        <td>{{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nsmgz21, 0, 'integer') }}</td>
        <td>{{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nsmgz22, 0, 'integer') }}</td>
        <td>...</td>
        <td>{{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nqmgz20, 0, 'integer') }}</td>
        <td>{{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nqmgz21, 0, 'integer') }}</td>
        <td>{{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nqmgz22, 0, 'integer') }}</td>
        <td>...</td>
        <td class="border-right-zero">{{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nomgz20, 0, 'integer') }}</td>
        <td class="border-right-zero">{{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nomgz21, 0, 'integer') }}</td>
        <td class="border-right-zero">{{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nomgz22, 0, 'integer') }}</td>
      </tr>
      <tr>
        <td class="border-bottom-zero border-right-zero" v-for="(item) in 12" :key="item"></td>
        <td class="border-bottom-zero border-right-zero border-left-zero">
          <img class="ww-100" :src="require('@/assets/images/brackets/Скобка_general_value_bot.svg')" alt=""/>
        </td>
        <td class="border-bottom-zero border-right-zero">
          <img class="ww-100" :src="require('@/assets/images/brackets/Скобка_general_value_bot.svg')" alt=""/>
        </td>
        <td class="border-bottom-zero border-right-zero">
          <img class="ww-100" :src="require('@/assets/images/brackets/Скобка_general_value_bot.svg')" alt=""/>
        </td>
      </tr>
      <tr>
        <td class="border-bottom-zero border-right-zero" v-for="(item) in 7" :key="item"></td>
        <td colspan="3" class="border-bottom-zero border-right-zero text-right">сумма по очной форме:</td>
        <td colspan="2" class="border-bottom-zero border-right-zero text-right">
          <div class="d-flex justify-end flex-row align-end formul-text">
              No
            <div class="little-text font-weight-medium mr-1">2021, 2022, 2023</div>
            =
          </div>

        </td>
        <td class="border-bottom-zero border-right-zero formul-text-table">
          {{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nobmo20, 0, 'integer') }}
        </td>
        <td class="border-bottom-zero border-right-zero formul-text-table">
          {{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nobmo21, 0, 'integer') }}
        </td>
        <td class="border-bottom-zero border-right-zero formul-text-table">
          {{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nobmo22, 0, 'integer') }}
        </td>
      </tr>
      <tr>
        <td class="border-bottom-zero border-right-zero" v-for="(item) in 7" :key="item"></td>
        <td colspan="3" class="border-bottom-zero border-right-zero text-right">сумма по очно-заочной форме:</td>
        <td colspan="2" class="border-bottom-zero border-right-zero text-right">
          <div class="d-flex justify-end flex-row align-end formul-text">
              Nv
            <div class="little-text font-weight-medium mr-1">2021, 2022, 2023</div>
            =
          </div>

        </td>
        <td class="border-bottom-zero border-right-zero formul-text-table">
          {{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nobmv20, 0, 'integer') }}
        </td>
        <td class="border-bottom-zero border-right-zero formul-text-table">
          {{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nobmv21, 0, 'integer') }}
        </td>
        <td class="border-bottom-zero border-right-zero formul-text-table">
          {{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nobmv22, 0, 'integer') }}
        </td>
      </tr>
      <tr>
        <td class="border-bottom-zero border-right-zero" v-for="(item) in 7" :key="item"></td>
        <td colspan="3" class="border-bottom-zero border-right-zero text-right">сумма по заочной форме:</td>
        <td colspan="2" class="border-bottom-zero border-right-zero text-right">
          <div class="d-flex justify-end flex-row align-end formul-text">
              Nz
            <div class="little-text font-weight-medium mr-1">2021, 2022, 2023</div>
            =
          </div>

        </td>
        <td class="border-bottom-zero border-right-zero formul-text-table">
          {{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nobmz20, 0, 'integer') }}
        </td>
        <td class="border-bottom-zero border-right-zero formul-text-table">
          {{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nobmz21, 0, 'integer') }}
        </td>
        <td class="border-bottom-zero border-right-zero formul-text-table">
          {{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nobmz22, 0, 'integer') }}
        </td>
      </tr>
      </tbody>
    </table>
    <v-row dense>
      <v-col cols="10">
        <p>
          <span class="font-weight-bold mb-1">Форма 5.03. (фрагмент)</span><br>
          Общая численность обучающихся по программам ординатуры, программам ассистентуры-стажировки, программам подготовки научных и научно-педагогических кадров в аспирантуре
          <br>
          по данным формы 1-НК, человек
        </p>
      </v-col>
    </v-row>
    <table>
      <thead>
      <tr>
        <th rowspan="3" colspan="3" class="text-left kcp-td">Уровни и формы образования</th>
        <th colspan="3">Обучающихся<br>
          (искл. квоту иностр.гражд.)
        </th>
        <th colspan="3">Иностранных граждан,<br>
          обучающихся по квоте
        </th>
         <th rowspan="3"  class="border-bottom-zero border-right-zero" style="min-width: 160px;border-bottom: 0!important;"></th>
        <th rowspan="2" class="border-right-zero" colspan="3">Всего обучающихся</th>
      </tr>
      <tr>
        <th colspan="3">

        </th>
        <th colspan="3"></th>
        <!--        <th colspan="3">-->
        <!--          Всего обучающихся-->
        <!--        </th>-->
      </tr>
      <tr>
        <th>
          на 01.01.2022 г.
        </th>
        <th>
          на 01.01.2023 г.
        </th>
        <th>
          на 01.01.2024 г.
        </th>

        <th>
          на 01.01.2022 г.
        </th>
        <th>
          на 01.01.2023 г.
        </th>
        <th>
          на 01.01.2024 г.
        </th>

        <th rowspan="2" class="border-bottom-zero">
          на 01.01.2022 г.<br/>
          <span class="font-weight-bold">гр.3 + гр.9 </span>
        </th>
        <th rowspan="2" class="border-bottom-zero">
          на 01.01.2023 г.<br/>
          <span class="font-weight-bold">гр.4 + гр.10 </span>
        </th >
        <th rowspan="2" class="border-right-zero" style="border-bottom: 0">
          на 01.01.2024 г.<br/>
          <span class="font-weight-bold">гр.5 + гр.11</span>
        </th>
      </tr>
      <tr>
        <th colspan="1" class="border-right-zero" style="text-align: left; border-top: 1px solid #B7CED9"><span>1</span></th>
        <th colspan="2" style="text-align: left; border-top: 1px solid #B7CED9"><span >2</span></th>
        <th v-for="(item) in 3" :key="item" style="border-top: 1px solid #B7CED9">{{ item + 2 }}</th>
        <th v-for="(item) in 3" :key="item" style="border-top: 1px solid #B7CED9">{{ item + 8 }}</th>
      </tr>
      </thead>
      <tbody>
      <tr>
        <td  style="text-align: left; " class="border-right-zero " >
          <span class="usl-name">Ординатура</span>
        </td>
        <td colspan="2" class="text-left kcp-name">все формы обучения</td>
        <td>{{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nsors20, 0, 'integer') }}</td>
        <td>{{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nsors21, 0, 'integer') }}</td>
        <td>{{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nsors22, 0, 'integer') }}</td>
        <td>{{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nqors20, 0, 'integer') }}</td>
        <td>{{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nqors21, 0, 'integer') }}</td>
        <td>{{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nqors22, 0, 'integer') }}</td>
        <td rowspan="2" class="border-bottom-zero"><img :src="require('@/assets/images/Vector_rigth_arrow.svg')" alt=""/></td>
        <td class="border-right-zero">{{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.noors20, 0, 'integer') }}</td>
        <td class="border-right-zero">{{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.noors21, 0, 'integer') }}</td>
        <td class="border-right-zero">{{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.noors22, 0, 'integer') }}</td>
      </tr>
      <tr>
        <td  style="text-align: left; " class="border-right-zero " >
          <span class="usl-name">Ассистентура</span>
        </td>
        <td colspan="2" class="text-left kcp-name">все формы обучения</td>
        <td>{{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nsass20, 0, 'integer') }}</td>
        <td>{{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nsass21, 0, 'integer') }}</td>
        <td>{{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nsass22, 0, 'integer') }}</td>
        <td>{{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nqass20, 0, 'integer') }}</td>
        <td>{{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nqass21, 0, 'integer') }}</td>
        <td>{{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nqass22, 0, 'integer') }}</td>
        <td class="border-right-zero">{{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.noass20, 0, 'integer') }}</td>
        <td class="border-right-zero">{{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.noass21, 0, 'integer') }}</td>
        <td class="border-right-zero">{{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.noass22, 0, 'integer') }}</td>
      </tr>
      <tr>
        <td class="border-bottom-zero border-right-zero" v-for="(item) in 10" :key="item"></td>
        <td class="border-bottom-zero border-right-zero border-left-zero">
          <img class="ww-100" :src="require('@/assets/images/brackets/Скобка_general_value_bot.svg')" alt=""/>
        </td>
        <td class="border-bottom-zero border-right-zero">
          <img class="ww-100" :src="require('@/assets/images/brackets/Скобка_general_value_bot.svg')" alt=""/>
        </td>
        <td class="border-bottom-zero border-right-zero">
          <img class="ww-100" :src="require('@/assets/images/brackets/Скобка_general_value_bot.svg')" alt=""/>
        </td>
      </tr>
      <tr>
        <td class="border-bottom-zero border-right-zero" v-for="(item) in 5" :key="item"></td>
        <td colspan="3" class="border-bottom-zero border-right-zero text-right">сумма по всем формам обучения:</td>
        <td colspan="2" class="border-bottom-zero border-right-zero text-right">
          <div class="d-flex justify-end flex-row align-end formul-text">
            NOA
            <div class="little-text font-weight-medium mr-1">2021, 2022, 2023</div>
            =
          </div>
        </td>
        <td class="border-bottom-zero border-right-zero formul-text-table">
          {{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nooas20, 0, 'integer') }}
        </td>
        <td class="border-bottom-zero border-right-zero formul-text-table">
          {{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nooas21, 0, 'integer') }}
        </td>
        <td class="border-bottom-zero border-right-zero formul-text-table">
          {{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nooas22, 0, 'integer') }}
        </td>
      </tr>
      </tbody>
    </table>
    <h3  class="b-indicator__collapse-subtitle my-3">Расчет приведенных контингентов:</h3>
    <div class="d-flex flex-row ">
      <div class="d-flex flex-column">
        <div class="formul-text"><span class="d-flex flex-row align-end">PN<span class="little-text " style="line-height:12px;">2021</span></span></div>
        <div class="formul-text"><span class="d-flex flex-row align-end">PN<span class="little-text " style="line-height:12px;">2022</span></span></div>
        <formulsFraction :need-bottom-line="false">
          <span class="d-flex flex-row align-end">PN<span class="little-text " style="line-height:12px;">2023</span></span>
        </formulsFraction>
      </div>
      <div class="d-flex flex-column ml-1">
        <div class="alternate-text">=</div>
        <div class="alternate-text">=</div>
        <formulsFraction :need-bottom-line="false">
          <div class="alternate-text">=</div>
        </formulsFraction>
      </div>
      <div class="d-flex flex-column">
        <div class="formul-text d-flex"><span class="alternate-text ">1,0 ×</span> <span class="d-flex flex-row align-end">No<span class="little-text " style="line-height:12px;">2021</span></span> </div>
        <div class="formul-text d-flex"><span class="alternate-text ">1,0 ×</span> <span class="d-flex flex-row align-end">No<span class="little-text " style="line-height:12px;">2022</span></span></div>
        <formulsFraction :need-bottom-line="true">
          <template>
            <span class="alternate-text mr-1">1,0 ×</span>
            <span class="d-flex flex-row align-end">No<span class="little-text " style="line-height:12px;">2023</span></span>
          </template>
          <template #bottom>очная <br>
            форма</template>
        </formulsFraction>
      </div>
      <div class="d-flex flex-column ml-1">
        <div class="alternate-text">+</div>
        <div class="alternate-text">+</div>
        <formulsFraction :need-bottom-line="false">
          <div class="alternate-text">+</div>
        </formulsFraction>
      </div>
      <div class="d-flex flex-column">
        <div class="formul-text d-flex"><span class="alternate-text ">   0,25 ×</span> <span class="d-flex flex-row align-end">Nv<span class="little-text " style="line-height:12px;">2021</span></span> </div>
        <div class="formul-text d-flex"><span class="alternate-text ">   0,25 ×</span> <span class="d-flex flex-row align-end">Nv<span class="little-text " style="line-height:12px;">2022</span></span></div>
        <formulsFraction :need-bottom-line="true">
          <template><span class="alternate-text mr-1">   0,25 ×</span><span class="d-flex flex-row align-end">Nv<span class="little-text " style="line-height:12px;">2023</span></span></template>
          <template #bottom>очно-заочная <br>
            форма</template>
        </formulsFraction>
      </div>
      <div class="d-flex flex-column ml-1">
        <div class="alternate-text">+</div>
        <div class="alternate-text">+</div>
        <formulsFraction :need-bottom-line="false">
          <div class="alternate-text">+</div>
        </formulsFraction>
      </div>
      <div class="d-flex flex-column">
        <div class="formul-text d-flex"><span class="alternate-text ">   0,1 ×</span> <span class="d-flex flex-row align-end">Nz<span class="little-text " style="line-height:12px;">2021</span></span></div>
        <div class="formul-text d-flex"><span class="alternate-text ">   0,1 ×</span> <span class="d-flex flex-row align-end">Nz<span class="little-text " style="line-height:12px;">2022</span></span></div>
        <formulsFraction :need-bottom-line="true">
          <template><span class="alternate-text mr-1">   0,1 ×</span><span class="d-flex flex-row align-end">Nz<span class="little-text " style="line-height:12px;">2023</span></span></template>
          <template #bottom>заочная <br>
            форма</template>
        </formulsFraction>
      </div>
      <div class="d-flex flex-column ml-1">
        <div class="alternate-text">+</div>
        <div class="alternate-text">+</div>
        <formulsFraction :need-bottom-line="false">
          <div class="alternate-text">+</div>
        </formulsFraction>
      </div>
      <div class="d-flex flex-column">
        <div class="formul-text d-flex"><span class="d-flex flex-row align-end">NOA<span class="little-text " style="line-height:12px;">2021</span></span></div>
        <div class="formul-text d-flex"><span class="d-flex flex-row align-end">NOA<span class="little-text " style="line-height:12px;">2022 </span></span></div>
        <formulsFraction :need-bottom-line="true">
          <template><span class="d-flex flex-row align-end">NOA<span class="little-text " style="line-height:12px;">2023</span></span></template>
          <template #bottom>ординатура +
            <br>
            ассистентура</template>
        </formulsFraction>
      </div>
      <div class="d-flex flex-column ml-1">
        <div class="alternate-text">=</div>
        <div class="alternate-text">=</div>
        <formulsFraction :need-bottom-line="false">
          <div class="alternate-text">=</div>
        </formulsFraction>
      </div>
      <div class="d-flex flex-column">
        <div class="formul-text"><span class="alternate-text ">1,0 ×</span> {{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nobmo20, 0, 'integer') }}</div>
        <div class="formul-text"><span class="alternate-text ">1,0 ×</span> {{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nobmo21, 0, 'integer') }}</div>
        <formulsFraction :need-bottom-line="true">
          <template><span class="alternate-text mr-1">1,0 ×</span>{{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nobmo22, 0, 'integer') }}</template>
          <template #bottom>очная <br>
            форма</template>
        </formulsFraction>
      </div>
      <div class="d-flex flex-column ml-1">
        <div class="alternate-text">+</div>
        <div class="alternate-text">+</div>
        <formulsFraction :need-bottom-line="false">
          <div class="alternate-text">+</div>
        </formulsFraction>
      </div>
      <div class="d-flex flex-column">
        <div class="formul-text"><span class="alternate-text ">   0,25 ×</span>    {{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nobmv20, 0, 'integer') }}</div>
        <div class="formul-text"><span class="alternate-text ">   0,25 ×</span>    {{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nobmv21, 0, 'integer') }}</div>
        <formulsFraction :need-bottom-line="true">
          <template><span class="alternate-text mr-1">   0,25 ×</span>   {{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nobmv22, 0, 'integer') }}</template>
          <template #bottom>очно-заочная <br>
            форма</template>
        </formulsFraction>
      </div>
      <div class="d-flex flex-column ml-1">
        <div class="alternate-text">+</div>
        <div class="alternate-text">+</div>
        <formulsFraction :need-bottom-line="false">
          <div class="alternate-text">+</div>
        </formulsFraction>
      </div>
      <div class="d-flex flex-column">
        <div class="formul-text"><span class="alternate-text ">   0,1 ×</span>    {{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nobmz20, 0, 'integer') }}</div>
        <div class="formul-text"><span class="alternate-text ">   0,1 ×</span>    {{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nobmz21, 0, 'integer') }}</div>
        <formulsFraction :need-bottom-line="true">
          <template><span class="alternate-text mr-1">   0,1 ×</span>    {{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nobmz22, 0, 'integer') }}</template>
          <template #bottom>заочная <br>
            форма</template>
        </formulsFraction>
      </div>
      <div class="d-flex flex-column ml-1">
        <div class="alternate-text">+</div>
        <div class="alternate-text">+</div>
        <formulsFraction :need-bottom-line="false">
          <div class="alternate-text">+</div>
        </formulsFraction>
      </div>
      <div class="d-flex flex-column">
        <div class="formul-text d-flex justify-center ">{{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nooas20, 0, 'integer') }}</div>
        <div class="formul-text d-flex justify-center ">    {{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nooas21, 0, 'integer') }}</div>
        <formulsFraction :need-bottom-line="true">
          <template><span class="d-flex flex-row align-center justify-center">  {{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nooas22, 0, 'integer') }}</span></template>
          <template #bottom>ординатура +
            <br>
            ассистентура</template>
        </formulsFraction>
      </div>
      <div class="d-flex flex-column ml-1">
        <div class="alternate-text">=</div>
        <div class="alternate-text">=</div>
        <formulsFraction :need-bottom-line="false">
          <div class="alternate-text">=</div>
        </formulsFraction>
      </div>
      <div class="d-flex flex-column">
        <div class="formul-text text-center">   {{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.norgp20, 1, 'float') }}</div>
        <div class="formul-text text-center">   {{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.norgp21, 1, 'float') }}</div>
        <formulsFraction :need-bottom-line="true">
          <template>    {{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.norgp22, 1, 'float') }}</template>
          <template #bottom>приведенный
            <br>
            контингент
          </template>
        </formulsFraction>
      </div>
    </div>
    <h3  class="b-indicator__collapse-subtitle my-3">Расчет значения показателя:</h3>
    <div class="d-flex flex-row align-center">
      <formulsFraction :need-bottom-line="true">
        <template>
          <div class="d-flex flex-row align-end">
            {{ item.title }}
            <div class="little-text ">0</div>
          </div>
        </template>
        <template #bottom>значение<br> показателя</template>
      </formulsFraction>
      <formulsFraction :need-bottom-line="false">
        <template>
          <span class="mt-8 alternate-text"> =</span>
        </template>
      </formulsFraction>
      <div class="d-flex align-center alternate-text mb-5" style="line-height: 70px; font-size: 55px">
        (
      </div>
      <formulsFractionSimple>
        <template>
          <div class="d-flex flex-row align-end mr-1">
            ОД
            <div class="little-text ">2021</div>
          </div>
        </template>
        <template #bottom>
          <div style="  min-height: 49px">
            <div class="d-flex flex-row formul-text align-end mr-1" >
              PN
              <div class="little-text ">2021</div>
            </div>
          </div>
        </template>
      </formulsFractionSimple>
      <formulsFraction :need-bottom-line="false">
        <template>
          <span class="mt-8 alternate-text">+</span>
        </template>
      </formulsFraction>
      <formulsFractionSimple>
        <template>
          <div class="d-flex flex-row align-end mr-1">
            ОД
            <div class="little-text ">2022</div>
          </div>
        </template>
        <template #bottom>
          <div style="  min-height: 49px">
            <div class="d-flex flex-row formul-text align-end mr-1" >
              PN
              <div class="little-text ">2022</div>
            </div>
          </div>
        </template>
      </formulsFractionSimple>
      <formulsFraction :need-bottom-line="false">
        <template>
          <span class="mt-8 alternate-text">+</span>
        </template>
      </formulsFraction>
      <formulsFractionSimple>
        <template>
          <div class="d-flex flex-row align-end mr-1">
            ОД
            <div class="little-text ">2023</div>
          </div>
        </template>
        <template #bottom>
          <div style="  min-height: 49px">
            <div class="d-flex flex-row formul-text align-end mr-1" >
              PN
              <div class="little-text ">2023</div>
            </div>
          </div>
        </template>
      </formulsFractionSimple>
      <div class="d-flex align-center alternate-text mb-5" style="line-height: 70px; font-size: 55px">
        )
      </div>
      <formulsFraction :need-bottom-line="false">
        <template>
          <span class="mt-8 ml-1 alternate-text"> ÷</span>
        </template>
      </formulsFraction>
      <formulsFraction :need-bottom-line="false" class="mr-1">
        <template>
          <span class="mt-8">n</span>
        </template>
      </formulsFraction>
      <formulsFraction :need-bottom-line="false">
        <template>
          <span class="mt-8 alternate-text"> =</span>
        </template>
      </formulsFraction>
      <div class="d-flex align-center alternate-text mb-5" style="line-height: 70px; font-size: 55px">
        (
      </div>
      <formulsFractionSimple>
        <template>
          <div class="d-flex flex-row align-end mr-1">
            {{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.doorg20, 1, 'float', true, '', (v) => {
            return Intl.NumberFormat('ru-RU').format(Number.parseFloat(v)).replace(',', '.')})   }}
          </div>
        </template>
        <template #bottom>
          <div style="  min-height: 49px">
            <div class="d-flex flex-row formul-text align-end mr-1" >
              {{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.norgp20, 1, 'float') }}
            </div>
          </div>
        </template>
      </formulsFractionSimple>
      <formulsFraction :need-bottom-line="false">
        <template>
          <span class="mt-8 alternate-text">+</span>
        </template>
      </formulsFraction>
      <formulsFractionSimple>
        <template>
          <div class="d-flex flex-row align-end mr-1">
            {{  $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.doorg21, 1, 'float', true, '', (v) => {
            return Intl.NumberFormat('ru-RU').format(Number.parseFloat(v)).replace(',', '.')})     }}
          </div>
        </template>
        <template #bottom>
          <div style="  min-height: 49px">
            <div class="d-flex flex-row formul-text align-end mr-1" >
              {{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.norgp21, 1, 'float') }}
            </div>
          </div>
        </template>
      </formulsFractionSimple>
      <formulsFraction :need-bottom-line="false">
        <template>
          <span class="mt-8 alternate-text">+</span>
        </template>
      </formulsFraction>
      <formulsFractionSimple>
        <template>
          <div class="d-flex flex-row align-end mr-1">
            {{   $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.doorg22, 1, 'float', true, '', (v) => {
            return Intl.NumberFormat('ru-RU').format(Number.parseFloat(v)).replace(',', '.')})      }}
          </div>
        </template>
        <template #bottom>
          <div style="  min-height: 49px">
            <div class="d-flex flex-row formul-text align-end mr-1" >
              {{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.norgp22, 1, 'float') }}
            </div>
          </div>
        </template>
      </formulsFractionSimple>
      <div class="d-flex align-center alternate-text mb-5" style="line-height: 70px; font-size: 55px">
        )
      </div>
      <formulsFraction :need-bottom-line="false">
        <template>
          <span class="mt-8 ml-1 alternate-text"> ÷</span>
        </template>
      </formulsFraction>
      <formulsFraction :need-bottom-line="false" class="mr-1">
        <template>
          <span class="mt-8">   {{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.norgpQ3, 0, 'integer') }}</span>
        </template>
      </formulsFraction>

      <formulsFraction :need-bottom-line="false">
        <template>
          <span class="mt-8"> =</span>
        </template>
      </formulsFraction>
      <formulsFraction :need-bottom-line="false">
        <template>
          <span class="mt-8">{{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data[item.dataFieldName+'b0'], item.prd+1, 'float') }}</span>
        </template>
      </formulsFraction>
    </div>
    <p>OДk	-	объем всех поступлений образовательной организации из всех источников в k-ом году;</p>
    <p>PNk	-	приведенный контингент студентов образовательной организации, по данным k-го года;</p>
    <p>n	-	число лет, за которые имеются отчетные данные PNk</p>
    <block-g v-bind="$props"/>
  </div>
</template>

<script>
import BlockOd from "@/components/cards/indicatiors/details/blockOd";
import BlockG from "@/components/cards/indicatiors/details/blockG";
import formulsFraction from "@/components/cards/indicatiors/formulsFraction";
import formulsFractionSimple from "@/components/cards/indicatiors/formulsFractionSimple"

export default {
  name: "b44",
  components: {BlockG, BlockOd, formulsFraction, formulsFractionSimple},
  props: {
    item: {
      type: Object
    },
    rowOfValues: {
      type: Object,
      default: () => {
      }
    },
  },
  methods: {},
}
</script>

<style lang="sass" scoped>

</style>